//=====================================================
//　規約同意チェックボックス
//=====================================================

import { ConstMsg } from "../utils/ConstMsg";
import { InputCheckBase } from "./InputCheckBase";
import { ValidErrMsgInline } from "./ValidErrMsgInline";

interface IFProps {
    name: string,
}

export function ChkRuleAgree(props: IFProps){

    //バリデーション
    const validations = {
        required: ConstMsg.EG0040009,
    }

    return (
        <div className="agreement-box">
            <iframe title="iframe-rule" className="agreement-box-content" src="/terms_of_service.html"></iframe>
            <ValidErrMsgInline name={props.name}/>
            <InputCheckBase name={props.name} title="上記規約に同意する" value="1" className="agreement-box-checkbox" validations={validations}/>
        </div>
    )

}